import React from 'react'

import css from '@styled-system/css'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import IconBase, { Path } from '@/components/IconBase'

const directions = ({ isRtl } = {}) => ({
  left: isRtl ? 180 : 0,
  right: isRtl ? 0 : 180,
  up: 90,
  down: 270,
})

const ArrowBox = styled(IconBase)(({ $direction, theme: { isRtl } }) =>
  css({
    svg: {
      transition: '0.3s',
      transform: `rotate(${directions({ isRtl })?.[$direction] ?? 0}deg)`,
    },
  }),
)

function ArrowRounded({
  color = 'icon.arrowBlue',
  direction = 'down',
  strokeWidth = '2',
  ...props
}) {
  return (
    <ArrowBox
      viewBox='0 0 14 22'
      display='flex'
      $direction={direction}
      {...props}
    >
      <Path
        d='M11.8203 20L2.82031 11L11.8203 2'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='transparent'
      />
    </ArrowBox>
  )
}

ArrowRounded.propTypes = {
  direction: PropTypes.string,
  color: PropTypes.string,
  strokeWidth: PropTypes.string,
}

export default ArrowRounded
